export enum StormDoorColor {
    Indeterminate = 0,
    White = 1,
    Black = 2,
    Gray = 3,
    Brown = 4,
    BeigeTan = 5,
    Green = 6,
    Any = 1000,
}

